// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"206":"fa91438a","406":"921b2d1e"}[chunkId] + ".css";
};